import { isServer } from './envUtils';
import { isFunction, isNotPresent, isPresent } from './typeUtils';

export const stopPropagation = (event: Event): false => {
  if (isPresent(event)) {
    event.preventDefault();
    event.stopPropagation();
  }
  return false;
};

export type EventListenerRemover = () => undefined;

export const addEventListener = (
  target: Document | HTMLElement,
  type: string,
  handler: EventListener // eslint-disable-line no-undef
): EventListenerRemover => {
  if (isNotPresent(target)) {
    return undefined;
  }
  target.addEventListener(type, handler);
  return () => {
    target.removeEventListener(type, handler);
    return undefined;
  };
};

// eslint-disable-next-line no-undef
export const initCustomEvent = <T>(eventType: string, init: CustomEventInit<T>): CustomEvent<T> => {
  if (isServer()) {
    return undefined;
  }

  if (isFunction(window.CustomEvent)) {
    return new CustomEvent(eventType, init);
  }

  const { detail, bubbles, cancelable } = init;
  const event: CustomEvent<T> = document.createEvent('CustomEvent');
  event.initCustomEvent(eventType, bubbles, cancelable, detail);
  return event;
};

export const isRadio = (elem: HTMLElement): elem is HTMLInputElement =>
  isPresent(elem) &&
  elem.tagName.toLowerCase() === 'input' &&
  (elem as HTMLInputElement).type.toLowerCase() === 'radio';
